<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="custom-table content">
    <div class="custom-table-row">
      <div class="custom-table-col">
        <app-generic-autocomplete [items]="tiposLancamento" displayField="nome" label="Tipo de lançamento"
          inputId="tipoLancamento" [(ngModel)]="tipoLancamento">
        </app-generic-autocomplete>
      </div>

      <div class="custom-table-col">
        <p-floatlabel variant="on">
          <input pInputText id="conta" [value]="tipoLancamento?.nomeConta ?? ''" readonly class="w-full" />
          <label for="conta">Conta do caixa</label>
        </p-floatlabel>
      </div>
    </div>
  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvar()">
      Salvar
    </button>
  </div>
</smrts-dialog>
